// extracted by mini-css-extract-plugin
export default {"container":"component_form_text_container__7Wn9a"};